// sensei-app/common/schemas/collections/enrollments.js
import { z } from "zod";

const EnrollmentSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    studentId: z.string().describe("The ID of the enrolled student user."),
    courseId: z.string().describe("The ID of the course."),
    status: z.enum(["active", "completed", "dropped"]).default("active"),
    enrolledAt: z.coerce.date().optional(),
    completedAt: z.coerce.date().optional().nullable(),
    
    documentInstanceId: z.string().optional().nullable().describe("The ID of the DocumentInstance dedicated to this specific enrollment."),
    schedulingPreferences: z.object({
        preferredDays: z.array(z.enum(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'])).optional(),
        preferredTime: z.string().regex(/^\d{2}:\d{2}$/, "Time must be in HH:mm format (e.g., '14:30')").optional(),
        itemsPerWeek: z.number().int().min(1).max(14).optional(),
    }).optional().nullable().describe("Student's scheduling preferences for this specific course."),
});

export default EnrollmentSchema;